import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { 
  FileText,
  LayoutDashboard, 
  Car, 
  MessageSquare, 
  LogOut, 
  Users,
  Briefcase,
  Star,
  Package
} from 'lucide-react';

const Sidebar = ({ isCollapsed }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    { name: 'Panel', icon: <LayoutDashboard size={20} />, path: '/admin' },
    { name: 'Araç Yönetimi', icon: <Car size={20} />, path: '/admin/vehicles' },
    { name: 'Marka & Model', icon: <Package size={20} />, path: '/admin/brands-models' },
    { name: 'Teklifler', icon: <FileText size={20} />, path: '/admin/quotes' },
    { name: 'Mesajlar', icon: <MessageSquare size={20} />, path: '/admin/messages' },
    { name: 'Yorumlar', icon: <Star size={20} />, path: '/admin/reviews' },
    { name: 'Araç Satım', icon: <Package size={20} />, path: '/admin/sell-requests' },
    { name: 'Hizmetler', icon: <Briefcase size={20} />, path: '/admin/services' },
    { name: 'Kullanıcılar', icon: <Users size={20} />, path: '/admin/users' },
  ];

  return (
    <aside className={`admin-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="admin-sidebar-header">
        <div className="admin-logo" onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
          <img src="/images/ErenisLogo.png" alt="Erenis Otomotiv" className="admin-logo-img" />
        </div>
        {!isCollapsed && (
          <p style={{ fontSize: '0.7rem', color: 'var(--text-dim)', marginTop: '0.2rem', opacity: 0.6, fontWeight: '700' }}>
            ADMIN PANEL
          </p>
        )}
      </div>

      <nav className="admin-nav">
        {menuItems.map((item, index) => (
          <NavLink 
            key={index} 
            to={item.path} 
            end={item.path === '/admin'}
            className={({ isActive }) => 
              isActive ? 'admin-nav-item active' : 'admin-nav-item'
            }
            title={isCollapsed ? item.name : ''}
          >
            {item.icon}
            {!isCollapsed && <span>{item.name}</span>}
          </NavLink>
        ))}
      </nav>

      <div className="admin-sidebar-footer">
        <button 
          onClick={handleLogout}
          className="admin-logout-btn"
          title={isCollapsed ? "Çıkış Yap" : ""}
        >
          <LogOut size={20} />
          {!isCollapsed && <span>Çıkış Yap</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
